'use client';

export { default } from '@/lib/components/RouteError/RouteError';
